import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Modal, Form, Spinner } from 'react-bootstrap';
import close from '../Asset/close.svg';
import Alert from './Alert';
import TimePicker from 'rc-time-picker';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import * as moment from 'moment';
import { ButtonGroup } from 'react-bootstrap';
import { Button } from "react-bootstrap";
import { useTable, useGlobalFilter, useAsyncDebounce, usePagination, useSortBy } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faArrowDownShortWide, faArrowUpWideShort } from '@fortawesome/free-solid-svg-icons';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Shift_Master() {
    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });
    
    let userObj = getUserInfo();
    let [sessOut,setSessOut] = useState(false);
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    }

    const handleClose1 = () =>
    {
        setShow1(false);
        setSiteEditErrorMsg({});
    } 
    //const handleShow1 = () => setShow1(true);
    const [loader, setLoader] = useState(true);
    let [allShift, setAllShift] = useState([]);
    //let [allAccount, setAllAccount] = useState([]);
    let [sites, setSites] = useState([]);
    let [formData, setformData] = useState({
        siteID: "",
        shiftName: "",
        startTime: "0000-00-00T00:00:00.000",
        endTime: "0000-00-00T00:00:00.000",
        isActive: true
    });
    let [currentData, setCurrentData] = useState({
        accountID: "",
        siteID: "",
        shiftName: "",
        startTime: "0000-00-00T00:00:00.000",
        endTime: "0000-00-00T00:00:00.000",
    });

    let [siteErrorMsg, setSiteErrorMsg] = useState({});
    function SiteValidate() {
        ////console.log("formdatavalidate", formData)
        let errror = {};
        if (formData.siteID == "") {
            errror.siteID = "This field is required";//Select Acoount"
        }
        if (formData.shiftName == "") {
            errror.shiftName = "This field is required";//Select Acoount"
        }
        if (formData.shiftName.length > 25) {
            errror.shiftName = "Exceeded 25 characters limit";//Select Acoount"
        }

        if (formData.startTime == "0000-00-00T00:00:00.000") {
            errror.startTime = "This field is required";//Select Acoount"
        }
        if (formData.endTime == "0000-00-00T00:00:00.000") {
            errror.endTime = "This field is required";//Select Acoount"
        }


        setSiteErrorMsg(errror);
        if (Object.keys(errror).length == 0) {
            saveShiftData();
        }
    }
    let [siteEditErrorMsg, setSiteEditErrorMsg] = useState({});
    function SiteEditValidate() {
        //console.log("formdatavalidate", formData)
        let errror = {};
        if (currentData.siteID == "") {
            errror.siteID = "This field is required";//Select Acoount"
        }
        if (currentData.shiftName == "") {
            errror.shiftName = "This field is required";//Select Acoount"
        }
        else if (currentData.shiftName.length > 25) {
            errror.shiftName = "Exceeded 25 characters limit";//Select Acoount"
        }

        if (currentData.startTime == "0000-00-00T00:00:00.000") {
            errror.startTime = "This field is required";//Select Acoount"
        }
        if (currentData.endTime == "0000-00-00T00:00:00.000") {
            errror.endTime = "This field is required";//Select Acoount"
        }


        setSiteEditErrorMsg(errror);
        if (Object.keys(errror).length == 0) {
            updateShiftData();
        }
    }


    useEffect(() => {
        let abortController = new AbortController();
        getShiftByAccount();
        getSiteByAccountId();

        return () => {
            abortController.abort();
          }
    }, [])

    const format = 'h:mm a';

    function addShiftTimeChange(value, fname) {
        //console.log("TPP:", value.format().slice(0, 17),fname);
        if(fname === "startTime")
        {
            setformData({ ...formData, [fname]: value.format().slice(0, 17) + "01.000Z" });
        }
        else
        {
            setformData({ ...formData, [fname]: value.format().slice(0, 17) + "00.000Z" });
        }
    }

    function getShiftByAccount() {
        fetch(environment.baseUrl + "getShiftByAccID", {
            method: "Post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({ "accountID": userObj.accountID })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setAllShift(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                  }
                else {
                    setAllShift([]);
                }
            })
        })
    }

    function getSiteByAccountId() {
        //let userObj = JSON.parse(sessionStorage.getItem("userInfo"));
        fetch(environment.baseUrl + "getSiteByUserAccount", {
            method: "Post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({ "accountID": userObj.accountID })
        }).then((result) => {

            result.json().then((res) => {
                if (res.code == 200) {
                    setSites(res.data.result.siteList);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                  }
                else {
                    setSites([])
                }
            })

        })
    }
    function saveShiftData() {
        //console.log(formData);
        fetch(environment.baseUrl + "addShift?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                accountID: userObj.accountID,
                siteID: formData.siteID,
                shiftName: formData.shiftName,
                startTime: formData.startTime,
                endTime: formData.endTime,
            })
        }).then((result) => {
            result.json().then((res) => {
                //console.log("addShiftRes:", res);
                if (res.code == 200) {
                    getShiftByAccount();
                }
                else if (res.code == 401) {
                    setSessOut(true);
                  }
                handleClose();
                setAlert({
                    msg: res.msg,
                    status: true
                })
                setformData({
                    accountID: "",
                    siteID: "",
                    shiftName: "",
                    startTime: "0000-00-00T00:00:00.000",
                    endTime: "0000-00-00T00:00:00.000",
                    isActive: true
                });
                getShiftByAccount();
            })
        })
    }
    function updateShiftData() {
        fetch(environment.baseUrl + "updateShift/" + currentData.shiftID, {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(currentData)
        }).then((result) => {
            result.json().then((res) => {
                //console.log("updateShiftRes:", res);
                if (res.code == 200) {
                    getShiftByAccount();
                }
                else if (res.code == 401) {
                    setSessOut(true);
                  }
                handleClose1();
                setCurrentData({
                    accountID: "",
                    siteID: null,
                    shiftName: "",
                    startTime: "",
                    endTime: "",
                });


                setAlert({
                    msg: res.msg,
                    status: true
                })

            })
        })
    }
    function getShftById(id) {
        fetch(environment.baseUrl + "shifts/" + id, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                //console.log(resp)
                getSiteByAccountId(resp.data.result[0].accountID);
                setCurrentData(resp.data.result[0]);
                let sh = parseInt((resp.data.result[0].startTime).slice(11, 13));
                let sm = parseInt((resp.data.result[0].startTime).slice(14, 16));
                let eh = parseInt((resp.data.result[0].endTime).slice(11, 13));
                let em = parseInt((resp.data.result[0].endTime).slice(14, 16));
                ////console.log("hhhmmm",h,m);
                setEditTime({
                    startTime: moment().hour(sh).minute(sm),//moment(resp.data.result[0].startTime).format("h:mm"),
                    endTime: moment().hour(eh).minute(em)
                })
                //editTime.startTime = moment().hour(h).minute(m);

                //setShow1(true);
                setLoader(false);
                //console.log(resp.data.result[0]);
            })
        })
    }
    function editShiftData(shiftId) {
        setCurrentData({
            accountID: "",
            siteID: null,
            shiftName: "",
            startTime: "",
            endTime: "",
        });
        setShow1(true);
        //console.log(shiftId);
        getShftById(shiftId);
        //rowIndex = (e.target.parentNode.parentNode.rowIndex) - 1;
        ////console.log(rowIndex,allShift[rowIndex]);
    }
    function getFormData(e) {
        if (e.target.name === "siteID") {
            setformData({ ...formData, [e.target.name]: parseInt(e.target.value) });
        }
        else if (e.target.name === 'endTime' || e.target.name === 'startTime') {
            let date = new Date();
            let today;
            var dd = String(date.getDate()).padStart(2, '0');
            var mm = String(date.getMonth() + 1).padStart(2, '0');
            var yyyy = date.getFullYear();
            today = yyyy + "-" + mm + "-" + dd + "T" + e.target.value + ":00.000";
            setformData({ ...formData, [e.target.name]: today });
        }
        else {
            setformData({ ...formData, [e.target.name]: e.target.value });
        }
        ////console.log(e.target.name,e.target.value);
        ////console.log(formData);
    }
    function getEditFormData(e) {
        //console.log()
        if (e.target.name === 'endTime' || e.target.name === 'startTime') {
            let date = new Date();
            let today;
            var dd = String(date.getDate()).padStart(2, '0');
            var mm = String(date.getMonth() + 1).padStart(2, '0');
            var yyyy = date.getFullYear();
            today = yyyy + "-" + mm + "-" + dd + "T" + e.target.value + ":00.000Z";
            setCurrentData({ ...currentData, [e.target.name]: today });
        }
        else {
            setCurrentData({ ...currentData, [e.target.name]: e.target.value });
        }

        function convertTime(fulltime) {
            if (fulltime != null) {
                let time = fulltime.slice(11, 16);
                let h = parseInt(time.slice(0, 2));
                if (h > 12) {
                    return ((h - 12) < 10 ? '0' + (h - 12) + time.slice(2) + " PM" : (h - 12) + time.slice(2) + " PM");
                }
                else {
                    return (time + " AM")
                }
            }
        }
    }
    function editShiftTimeChange(value, fname) {
        //console.log(value, fname);
        let temp = value.format().slice(0, 17);
        let h = parseInt(temp.slice(11, 13));
        let m = parseInt(temp.slice(14, 16));
        //console.log("TPP:", temp);
        setEditTime({ ...editTime, [fname]: moment().hour(h).minute(m) })

        setCurrentData({ ...currentData, [fname]: temp + ".000Z" });
        if(fname === "startTime")
        {
            setCurrentData({ ...currentData, [fname]: temp + "01.000Z" });
        }
        else
        {
            setCurrentData({ ...currentData, [fname]: temp + "00.000Z" });
        }
    }
    let [editTime, setEditTime] = useState({
        startTime: moment().hour(0).minute(0),
        endTime: moment().hour(0).minute(0)
    });
    function convertTime(fulltime) {
        if (fulltime != null) {
            let time = fulltime.slice(11, 16);
            let h = parseInt(time.slice(0, 2));
            if (h > 12) {
                return ((h - 12) < 10 ? '0' + (h - 12) + time.slice(2) + " PM" : (h - 12) + time.slice(2) + " PM");
            }
            else {
                return (time + " AM")
            }
        }
    }
    //////////////////////////////////////////////
    const columns = useMemo(
        () => [
            {
                Header: 'Account Name',
                accessor: 'accountName', // accessor is the "key" in the data
            },
            {
                Header: 'Site Name',
                accessor: 'siteName',
            },
            {
                Header: 'Shift Name	 ',
                accessor: 'shiftName',
            },
            {
                Header: 'Start Time ',
                accessor: 'startTime',
            },
            {
                Header: 'End Time ',
                accessor: 'endTime',
            },

            // {
            //     Header: 'Action ',
            //     accessor: 'action',
            // },

        ],
        []
    )
    function GlobalFilter({ preGlobalFilteredRows, globalFilter, setGlobalFilter, }) {
        const count = preGlobalFilteredRows.length
        const [value, setValue] = React.useState(globalFilter)
        const onChange = useAsyncDebounce(value => {
            setGlobalFilter(value || undefined)
        }, 200)
        return (
            <Form.Group>
                <Form.Control type="text"
                    style={{ width: '170px' }}
                    value={value || ""}
                    onChange={e => {
                        setValue(e.target.value);
                        onChange(e.target.value);
                    }} className="textbox-back"
                    placeholder={`search`}
                />
            </Form.Group>
        )
    }

    function Table({ columns, data }) {
        // Use the state and functions returned from useTable to build your UI
        const {
            getTableProps,
            getTableBodyProps,
            headerGroups,
            //rows,//use when we not use pagination
            page,//use when we use pagination
            prepareRow,
            //for globle filter
            state,
            preGlobalFilteredRows,
            setGlobalFilter,
            //for pagination
            canPreviousPage,
            canNextPage,
            pageOptions,
            pageCount,
            gotoPage,
            nextPage,
            previousPage,
            setPageSize,
            state: { pageIndex, pageSize },
        } = useTable({ columns, data, }, useGlobalFilter, useSortBy, usePagination)

        return (
            <>
                <div className="row">
                    <div className="col-sm-4 left-col">
                        <GlobalFilter
                            preGlobalFilteredRows={preGlobalFilteredRows}
                            globalFilter={state.globalFilter}
                            setGlobalFilter={setGlobalFilter}
                        />
                    </div>
                    {/* <div className="col-sm-8 right-col  text-end d-none">
                        <button onClick={handleShow} className='btn-primary add-btn'>Add <i className='fa fa-plus-circle ml-2'></i></button>
                    </div> */}
                </div>
                {/* </div> */}
                <div className="table-responsive mt-3">
                    <table {...getTableProps()} className="table">
                        <thead className='table-secondary'>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            style={{ whiteSpace: 'nowrap' }} className={column.render('Header') == "Action "?"text-center":""}
                                        >
                                            {column.render('Header')} &nbsp;
                                            <span>
                                                {
                                                    column.render('Header') == "Action "?
                                                        "" :
                                                        <span>
                                                            {column.isSorted
                                                                ? column.isSortedDesc
                                                                    ? <FontAwesomeIcon icon={faArrowDownShortWide} />
                                                                    : <FontAwesomeIcon icon={faArrowUpWideShort} />
                                                                : <FontAwesomeIcon icon={faSort} />}
                                                        </span>
                                                }
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map(row => {
                                ////console.log("rowssss:", row);
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            // if (cell.column.id == "action") {
                                            //     return (
                                            //         <td
                                            //             {...cell.getCellProps()} className="text-center"
                                            //         >
                                            //             <i className='fa fa-pencil ' onClick={() => editShiftData(row.original.shiftID)} style={{ fontSize: '22px', color: '#0077B9' }} />
                                            //         </td>
                                            //     )
                                            // }

                                            // else 
                                            if (cell.column.id == "endTime") {
                                                return (
                                                    <td
                                                        {...cell.getCellProps()}
                                                    >
                                                        {convertTime(row.original.endTime)}
                                                    </td>
                                                )
                                            }
                                            else if (cell.column.id == "startTime") {
                                                return (
                                                    <td
                                                        {...cell.getCellProps()}
                                                    >
                                                        {convertTime(row.original.startTime)}
                                                    </td>
                                                )
                                            }
                                            else {
                                                return (
                                                    <td
                                                        {...cell.getCellProps()}
                                                        style={{ whiteSpace: 'nowrap' }}
                                                    >

                                                        {cell.render('Cell')}
                                                    </td>

                                                )

                                            }
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="row mt-2">
                    <div className="col-sm-5 left-col">
                        <ButtonGroup aria-label="Basic example">
                            <Button variant="primary" className="pagi-btn" onClick={() => gotoPage(0)} disabled={!canPreviousPage}><i className="fa fa-angle-double-left"></i></Button>
                            <Button variant="primary" className="pagi-btn" onClick={() => previousPage()} disabled={!canPreviousPage}><i className="fa fa-angle-left"></i></Button>
                            <Button variant="primary" className="pagi-btn" onClick={() => nextPage()} disabled={!canNextPage}><i className="fa fa-angle-right"></i></Button>
                            <Button variant="primary" className="pagi-btn" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}><i className="fa fa-angle-double-right"></i></Button>
                        </ButtonGroup>
                        &nbsp;
                        <span>
                            Page{' '}
                            <strong>
                                {pageIndex + 1} of {pageOptions.length}
                            </strong>{' '}
                        </span>
                    </div>
                    <div className="col-sm-4"></div>
                    <div className="col-sm-3 right-col">
                        <Form.Group className="mb-3" >
                            <Form.Select as="select" className="textbox-back" value={pageSize}
                                onChange={e => {
                                    setPageSize(Number(e.target.value))
                                }}>
                                {[5, 10, 20, 30, 40, 50].map(pageSize => (
                                    <option key={pageSize} value={pageSize}>
                                        Show {pageSize} Rows
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </div>
                </div>
            </>
        )
    }



    return (
        <div className='main-container'>
            <SessionFun show = {sessOut}></SessionFun>
            <Alert obj={alert} />
            <h4 className='main-heading'>Shift</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;
                <i className='fa fa-angle-right'></i></Link>&nbsp;Shift
            </p>
            <div className="card-box-block mt-3" style={{ width: "100%" }}>
                <Table columns={columns} data={allShift} />
            </div>


            <Modal show={show} onHide={handleClose} centered backdrop="static">
                <Modal.Header>
                    <Modal.Title>Add Shift</Modal.Title>
                    <button onClick={handleClose} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className=' logout-box'>
                    <div className="row">
                        <div className="col-sm-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>Select Site</Form.Label>
                                <Form.Select as="select" name='siteID' className="textbox-back" onChange={getFormData}>
                                    {/* value={setAllShift[rowIndex].siteID} */}
                                    <option value="1">Select Site</option>
                                    {
                                        sites.map((item, index) =>
                                            <option key={index} value={item.siteID}>{item.siteName}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{siteErrorMsg.siteID}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>Enter Shift Name</Form.Label>
                                <Form.Control type="text" name='shiftName' className="textbox-back" onChange={getFormData} />
                                {/* value={setAllShift[rowIndex].shiftName} */}
                                <small className='red'>{siteErrorMsg.shiftName}</small>
                            </Form.Group>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>Shift Start Time</Form.Label>
                                {/* <Form.Control type="time" name='startTime' className="textbox-back" onChange={getFormData} /> */}
                                <TimePicker
                                    showSecond={false}
                                    className="form-control textbox-back"
                                    onChange={(e) => addShiftTimeChange(e, "startTime")}
                                    format={format}
                                    minuteStep={5}
                                    use12Hours
                                    inputReadOnly
                                    placeholder="Shift Start Time"
                                />
                                <small className='red'>{siteErrorMsg.startTime}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>Shift End Time</Form.Label>
                                {/* <Form.Control type="time" name='endTime' className="textbox-back" onChange={getFormData} /> */}
                                <TimePicker
                                    showSecond={false}
                                    className="form-control textbox-back"
                                    onChange={(e) => addShiftTimeChange(e, "endTime")}
                                    format={format}
                                    minuteStep={5}
                                    use12Hours
                                    inputReadOnly
                                    placeholder="Shift End Time"
                                />
                                <small className='red'>{siteErrorMsg.endTime}</small>
                            </Form.Group>
                        </div>

                    </div>
                    <div className="row text-center mt-3">
                        <div className="col-sm-6">
                            <button className="btn btn-outline-secondary lo-btn float-end" onClick={handleClose}>
                                Cancel
                            </button>
                        </div>
                        <div className="col-sm-6">
                            <button className="btn btn-light lo-btn confirm-btn float-start" onClick={SiteValidate}>
                                Save
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>


            {/* edit screen */}
            <Modal show={show1} onHide={handleClose1} centered backdrop="static">
                <Modal.Header>
                    <Modal.Title>Edit Shift</Modal.Title>
                    <button onClick={handleClose1} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className=' logout-box'>
                    <div className="row">
                        <div className="col-sm-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>Select Site</Form.Label>
                                <Form.Control disabled as="select" name='siteID' value={currentData.siteID} className="textbox-back" onChange={getFormData}>
                                    {/* value={setAllShift[rowIndex].siteID} */}
                                    <option value="">Select Site</option>
                                    {
                                        sites.map((item, index) =>
                                            <option key={index} value={item.siteID}>{item.siteName}</option>
                                        )
                                    }
                                </Form.Control>
                            </Form.Group>
                        </div>
                        <div className="col-sm-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>Enter Shift Name</Form.Label>
                                <Form.Control type="text" name='shiftName' value={currentData.shiftName} className="textbox-back" onChange={getEditFormData} />
                                {/* value={setAllShift[rowIndex].shiftName} */}
                                <small className='red'>{siteEditErrorMsg.shiftName}</small>
                            </Form.Group>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>Shift Start Time</Form.Label>
                                {/* value={currentData.startTime} onChange={getEditFormData} .slice(11, 16);*/}
                                <TimePicker
                                    value={editTime.startTime}
                                    showSecond={false}
                                    className="form-control textbox-back"
                                    onChange={(e) => editShiftTimeChange(e, "startTime")}
                                    format={format}
                                    minuteStep={5}
                                    use12Hours
                                    inputReadOnly
                                    placeholder="Shift Start Time"
                                    disabled
                                />
                                {/* value={currentData.startTime} onChange={getEditFormData} .slice(11, 16);*/}
                            </Form.Group>
                        </div>
                        <div className="col-sm-6">
                            <Form.Group className="mb-3" >
                                <Form.Label>Shift End Time</Form.Label>
                                {/* value={currentData.startTime} onChange={getEditFormData} .slice(11, 16);*/}
                                <TimePicker
                                    value={editTime.endTime}
                                    showSecond={false}
                                    className="form-control textbox-back"
                                    onChange={(e) => editShiftTimeChange(e, "endTime")}
                                    format={format}
                                    minuteStep={5}
                                    use12Hours
                                    inputReadOnly
                                    placeholder="Shift End Time"
                                    disabled
                                />
                            </Form.Group>
                        </div>

                    </div>
                    <div className="row text-center mt-3">
                        <div className="col-sm-6">
                            <button className="btn btn-outline-secondary lo-btn float-end" onClick={handleClose1}>
                                Cancel
                            </button>
                        </div>
                        <div className="col-sm-6">
                            <button className="btn btn-light lo-btn confirm-btn float-start" onClick={SiteEditValidate}>
                                Update
                            </button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </div>
    )
}

export default Shift_Master
